import Swiper from 'swiper/bundle';


if ($('.home-slider').length) {
	var sliderHome = new Swiper('.home-slider', {
		slidesPerView: 1,
		spaceBetween: 0,
		autoResize: true,
		speed: 600,
		effect: "creative",
		creativeEffect: {
			prev: {
				shadow: false,
				translate: ["-20%", 0, -1],
			},
			next: {
				translate: ["100%", 0, 0],
			},
		},
		autoplay: {
			delay: 3000,
			pauseOnMouseEnter: true,
		},
		navigation: false,
		scrollbar: false,
		pagination: {
			el: '.home-slider-pagination',
			type: 'bullets',
			clickable: true,
		},
		loop: false,
		touchEventsTarget: 'wrapper'
	}).on('slideChangeTransitionStart', function(swiper) {
		var headingEl = $('.home-slider-section h1');
		headingEl.css('transform', 'translateY(20px)');
		headingEl.css('opacity', '0');

		setTimeout(function() { 
			var realIndex = sliderHome.realIndex;
			var heading = $(swiper.slides[realIndex]).data('heading');
			headingEl.html(heading);
			headingEl.parent().css('height', headingEl.outerHeight());
			headingEl.css('transform', 'translateX(0px)');
			headingEl.css('opacity', '1');
		}, 300);

	});
}


if ($('.services-slider').length) {
	var sliderServices = new Swiper('.services-slider', {
		slidesPerView: 1,
		spaceBetween: 16,
		autoResize: false,
		speed: 600,
		navigation: {
			nextEl: $('.services-slider-section .swiper-button-next.desktop')[0],
			prevEl: $('.services-slider-section .swiper-button-prev.desktop')[0],
		},
		autoplay: false,
		scrollbar: false,
		pagination: false,
		loop: false,
		touchEventsTarget: 'wrapper',
        breakpoints: {
            640: {
				slidesPerView: 1.5,
            },
            768: {
				slidesPerView: 2,
            },
            1024: {
				slidesPerView: 2.5,
            },
            1280: {
				slidesPerView: 3.5,
            },
            1920: {
				slidesPerView: 4,
            },
        },
	}).on('slideChange', function() {
		if ($('.services-slider-section .swiper-button-next.desktop.swiper-button-disabled').length) {
			$('.services-slider-section .swiper-button-next.mobile').addClass('swiper-button-disabled');
		} else {
			$('.services-slider-section .swiper-button-next.mobile').removeClass('swiper-button-disabled');
		}
		if ($('.services-slider-section .swiper-button-prev.desktop.swiper-button-disabled').length) {
			$('.services-slider-section .swiper-button-prev.mobile').addClass('swiper-button-disabled');
		} else {
			$('.services-slider-section .swiper-button-prev.mobile').removeClass('swiper-button-disabled');
		}
	});
}


if ($('.news-slider').length) {
	var sliderNews = new Swiper('.news-slider', {
		slidesPerView: 1,
		spaceBetween: 16,
		autoResize: false,
		autoHeight: true,
		speed: 600,
		navigation: {
			nextEl: $('.news-slider-section .swiper-button-next.desktop')[0],
			prevEl: $('.news-slider-section .swiper-button-prev.desktop')[0],
		},
		autoplay: false,
		scrollbar: false,
		pagination: false,
		loop: false,
		touchEventsTarget: 'wrapper',
        breakpoints: {
            640: {
				slidesPerView: 1.5,
            },
            768: {
				slidesPerView: 1.8,
            },
            1024: {
				slidesPerView: 2.2,
            },
            1280: {
				slidesPerView: 3,
            },
        },
	}).on('slideChange', function() {
		if ($('.news-slider-section .swiper-button-next.desktop.swiper-button-disabled').length) {
			$('.news-slider-section .swiper-button-next.mobile').addClass('swiper-button-disabled');
		} else {
			$('.news-slider-section .swiper-button-next.mobile').removeClass('swiper-button-disabled');
		}
		if ($('.news-slider-section .swiper-button-prev.desktop.swiper-button-disabled').length) {
			$('.news-slider-section .swiper-button-prev.mobile').addClass('swiper-button-disabled');
		} else {
			$('.news-slider-section .swiper-button-prev.mobile').removeClass('swiper-button-disabled');
		}
	});
}


$(function () {
	
	if ($('.home-slider').length) {
		var headingEl = $('.home-slider-section h1');
		headingEl.parent().css('height', headingEl.outerHeight());
	}

	if ($('.circles-slider').length) {
		$('.circles-slider').each(function(i) {
			circlesSliderInit($(this), i);
		});
	}

});

$(window).on('resize', function() {
	
	if ($('.home-slider').length) {
		var headingEl = $('.home-slider-section h2');
		headingEl.parent().css('height', headingEl.outerHeight());
	}

	if ($('.circles-slider').length) {
		$('.circles-slider').each(function(i) {
			circlesSliderInit($(this), i);
		});
	}

	if ($('.news-slider').length) {
		sliderNews.update();
	}

});


$(document).on('click', '.services-slider-section .swiper-button-prev.mobile', function(e) {
	e.stopPropagation();
	$('.services-slider-section .swiper-button-prev.desktop').trigger('click');
});
$(document).on('click', '.services-slider-section .swiper-button-next.mobile', function(e) {
	e.stopPropagation();
	$('.services-slider-section .swiper-button-next.desktop').trigger('click');
});
$(document).on('click', '.news-slider-section .swiper-button-prev.mobile', function(e) {
	e.stopPropagation();
	$('.news-slider-section .swiper-button-prev.desktop').trigger('click');
});
$(document).on('click', '.news-slider-section .swiper-button-next.mobile', function(e) {
	e.stopPropagation();
	$('.news-slider-section .swiper-button-next.desktop').trigger('click');
});


let sliderCirclesInit = [];


var sliderCircles = Swiper;
// var sliderCirclesInit = false;

function circlesSliderInit(slider, i) {
	// console.log(slider)
	// console.log(slider.data('slides'))

	var slides = slider.data('slides');
	switch (slides) {
		case 1:
			var mobile = window.matchMedia('(max-width: 1023px)');
			var desktop = window.matchMedia('(min-width: 1024px)');
			break;
		case 2:
			var mobile = window.matchMedia('(max-width: 1023px)');
			var desktop = window.matchMedia('(min-width: 1024px)');
			break;
		case 3:
			var mobile = window.matchMedia('(max-width: 1279px)');
			var desktop = window.matchMedia('(min-width: 1280px)');
			break;
	
		default:
			var mobile = window.matchMedia('(max-width: 1695px)');
			var desktop = window.matchMedia('(min-width: 1696px)');
			break;
	}
	
	if(mobile.matches) {
		// console.log('mob')
		// console.log(sliderCirclesInit[i])
		if (!sliderCirclesInit[i]) {
			sliderCirclesInit[i] = true;

			// $('.circles-slider').each(function(i) {
				// Enable (for mobile)
				var sliderCircles = new Swiper($(slider)[0], {
					slidesPerView: 1.2,
					spaceBetween: 16,
					autoResize: true,
					speed: 600,
					navigation: false,
					autoplay: false,
					scrollbar: false,
					pagination: false,
					loop: false,
					touchEventsTarget: 'wrapper',
					centeredSlides: true,
					breakpoints: {
						640: {
							slidesPerView: 1.5,
						},
						768: {
							slidesPerView: 1.8,
						},
						1024: {
							slidesPerView: 2.5,
						},
						1280: {
							slidesPerView: 3,
						},
					},
				});
			// });
		}

	}

	// Disable (for desktop)
	else if(desktop.matches) {
		// console.log('des')
		try {
			// $('.circles-slider').each(function(i) {
				var circles = $(slider)[0].swiper;
				// const circles = slider.swiper;
				circles.destroy(true, true);
			// });
		} catch(err) {
			// alert("err");
		}
		sliderCirclesInit[i] = false;
	}
}
